import UpdateHireExpertJobDetails from "../PostRequirements/UpdatePost/UpdateHireExpertJobDetails";

export default function HireExpertJobDetails() {
  return (
    <div>
      <UpdateHireExpertJobDetails />
    </div>
  );
}
